<script setup lang="ts">
import SubmitButton from '@/components/forms/SubmitButton/SubmitButton.vue';
import { useIsSubmitting } from 'vee-validate';
import { SubmitButtonProps } from '../types';

const submitting = useIsSubmitting();

export type VeeSubmitButtonProps = SubmitButtonProps;

defineProps<VeeSubmitButtonProps>();
</script>

<template>
  <SubmitButton v-bind="$props" :loading="submitting || loading" />
</template>
